import React from "react";
import GA from "./Helper/GoogleAnalytics";
import { Route, Switch, BrowserRouter, Redirect } from "react-router-dom";
import TeacherRoute from "./Auth/TeacherRoute";
import AdminRoute from "./Auth/AdminRoute";
import CustomerRoute from "./Auth/CustomerRoute";
import PersonnelRoute from "./Auth/PersonnelRoute";
import AuthorRoute from "./Auth/AuthorRoute";
import UserRoute from "./Auth/UserRoute";

// Test
import TestAdmin from "./Auth/TestAdmin";
import TestUser from "./Auth/TestUser";

// login and signup
import Login from "./Components-Pages/Login/Login";
import LoginAsInstitution from "./Components-Pages/Login/LoginAsInstitution";

import RegisterOption from "./Components-Pages/Register/RegisterOption";
import Register from "./Components-Pages/Register/Register";
import RegisterCollege from "./Components-Pages/RegisterCollege/RegisterCollege";
import TeacherOption from "./Components-Pages/Register/TeacherOption";

import BeforeEmailConfirm from "./Components-Pages/Register/BeforeEmailConfirm";
import Confirm from "./Components-Pages/Register/Confirm";
import ConfirmCollege from "./Components-Pages/RegisterCollege/ConfirmCollege";
import ConfirmPersonnel from "./Components-Pages/RegisterCollege/ConfirmPersonnel";
import secondaryRegistration from "./Components-Pages/SecondaryRegistration/SecondaryRegistration";
import AlreadyRegistered from "./Components-Pages/SecondaryRegistration/AlreadyRegistered";

import secondaryRegistrationCollege from "./Components-Pages/SecondaryRegistration/SecondaryRegistrationCollege";
import secondaryRegistrationPersonnel from "./Components-Pages/SecondaryRegistration/SecondaryRegistrationPersonnel";

import ResetPassword from "./Components-Pages/ResetPassword/ResetPassword";
import ResetSendEmail from "./Components-Pages/ResetPassword/ResetSendEmail";

// Teacher
// profile and resume
import Home2 from "./Components-Pages/Home/Home2";
import PreviewProfile3 from "./Components-Pages/Home/PreviewProfile2.redux";
import Resume3 from "./Components-Pages/Resume/Resume2.redux";
import PreviewResume3 from "./Components-Pages/Resume/PreviewResume2.redux";
import PreviewVetResume from "./Components-Pages/Resume/Vocational/VocationalPreviewResume";
import VocationalResume from "./Components-Pages/Resume/VocationalResume";

import NavigateToPreviewProfile from "./Components-Pages/Home/NavigateToPreviewProfile";
import NavigateToShareProfile from "./Components-Pages/Home/NavigateToShareProfile";
import ShareProfile from "./Components-Pages/Home/SharedProfile2";
import SharedResume from "./Components-Pages/Resume/SharedResume2";
import SharedVetResume from "./Components-Pages/Resume/Vocational/VocationalSharedResume";

// availability
import Availability from "./Components-Pages/Availability/Availability";
// import JobList from "./Components-Pages/Bookings2/JobList"
import TeacherJobList2 from "./Components-Pages/Bookings2/TeacherJobList2";

// personal info
import PersonalDetails2 from "./Components-Pages/User2/PersonalDetails2";
import EmergencyContact2 from "./Components-Pages/User2/EmergencyContact2";
import PreferredWorkLocations from "./Components-Pages/User2/PreferredWorkLocations";
import MyAccount from "./Components-Pages/Account/MyAccount";
import CollegeAccount from "./Components-Pages/Account/CollegeAccount";

// identification
import PersonalID2 from "./Components-Pages/User2/PersonalId2";
import PoliceCheck2 from "./Components-Pages/User2/PoliceCheck2";
import Visa2 from "./Components-Pages/User2/Visa2";
import WWCC2 from "./Components-Pages/User2/WWCC2";
import PayLevel from "./Components-Pages/User2/PayLevel";

// bank and super
import BankDetails from "./Components-Pages/User2/BankDetails";
import Tax2 from "./Components-Pages/User2/Tax2";
import Super2 from "./Components-Pages/User2/Super2";

// user manual
import TeacherUserManual from "./Components-Pages/UserManual/TeacherUserManual";
import CollegeUserManual from "./Components-Pages/UserManual/CollegeUserManual";

// dashboard
import Dashboard from "./Components-Pages/Dashboard/Dashboard";

// job listings
import JobBoard from "./Components-Pages/JobBoard/Teacher/SearchJobs";
import SavedJobs from "./Components-Pages/JobBoard/Teacher/SavedJobs";
import MyApplications from "./Components-Pages/JobBoard/Teacher/MyApplications";
import ConfirmApplication from "./Components-Pages/JobBoard/Teacher/ConfirmApplication";
import MyListings from "./Components-Pages/JobBoard/College/MyListings";
import ViewApplicants from "./Components-Pages/JobBoard/College/ViewApplicants";
import ViewApplicantsAdmin from "./Components-Pages/JobBoard/ViewApplicantsAdmin";
import JobListing from "./Components-Pages/JobBoard/JobListing";
import PostJobDraft from "./Components-Pages/JobBoard/College/PostJobDraft";
import PostJobPreview from "./Components-Pages/JobBoard/College/PostJobPreview";
import EditListing from "./Components-Pages/JobBoard/College/EditListing";
import MyDrafts from "./Components-Pages/JobBoard/College/MyDrafts";

// Arbitary user
// reference check
import NavigateToReferenceForm from "./Components-Pages/PublicPage/Reference/NavigateToReferenceForm";
import ReferenceForm from "./Components-Pages/PublicPage/Reference/ReferenceForm";

// ellyf rating
import NavigateToRating from "./Components-Pages/PublicPage/Rating/NavigateToRating";
import Rating from "./Components-Pages/PublicPage/Rating/rating";

// Below are pages used by admin only, or prototypes not used in the main platform
// Admin
// teacher list single profile - will be redone
import AllTeachers from "./Components-Pages/Admin/AllTeachersArchived";
import AllTeachersTable from "./Components-Pages/Admin/AllTeachersTable";
import TeacherpersonalDetails from "./Components-Pages/Admin/TeacherpersonalDetails";
import ValidateDocuments from "./Components-Pages/ValidateDocuments/ValidateDocuments";
import TeacherJoblist from "./Components-Pages/Admin/TeacherJoblist";
import TeacherNote from "./Components-Pages/Admin/TeacherNote";
import AdminQualification from "./Components-Pages/Admin/Qualification"

// Admin
// college list profiles - lieh
import AllCustomers from "./Components-Pages/Admin/AllCustomers";

// All Colleges
import AllColleges from "./Components-Pages/Admin/Colleges/AllColleges";
import AllArchivedColleges from "./Components-Pages/Admin/Colleges/AllArchivedColleges";
import CollegeDetails from "./Components-Pages/Admin/Colleges/CollegeDetails";
import CollegeDetailCalendar from "./Components-Pages/Admin/Colleges/Details/CollegeDetailCalendar";
import CollegeDetailJobs from "./Components-Pages/Admin/Colleges/Details/CollegeDetailJobs";
import CollegeDetailPersonnel from "./Components-Pages/Admin/Colleges/Details/CollegeDetailPersonnel";
import CollegeDetailCampus from "./Components-Pages/Admin/Colleges/Details/CollegeDetailCampus";
import CollegeDetailTimetable from "./Components-Pages/Admin/Colleges/Details/CollegeDetailTimetable";
import CollegeDetailListings from "./Components-Pages/Admin/Colleges/Details/CollegeDetailListings";

// assign bookings
import AssignBookings from "./Components-Pages/Admin/AssigningBookings"
import InvoiceTable from "./Components-Pages/Admin/InvoiceComponent"
import InvoiceDetails from "./Components-Pages/PDFKit/InvoiceViewerComponent"
import MultipleTeacherAllocation from "./Components-Pages/Admin/Allocation/MultipleTeacherAllocation"
import AllocationTablePage from "./Components-Pages/Admin/Allocation/AllocationTablePage"
import AllocationTableNewPage from "./Components-Pages/Admin/Allocation/AllocationTableNewPage"
import allocateET from "./Components-Pages/Admin/Allocation/allocateET";
import eventCalendar from "./Components-Pages/Admin/AnnualCalendar";
import morningET from "./Components-Pages/Admin/Allocation/morningET";
import managerReport from "./Components-Pages/Admin/ManagerReport";

// user logs
import UserLogs from "./Components-Pages/Admin/UserLogs";

// teacher's banking - view only
import TeacherBanking from "./Components-Pages/Admin/TeacherBanking";
import TeacherCalendar from "./Components-Pages/Admin/TeacherCalendar";

// College
// college pages created by previous design - will be redone
import CollegeCalendar from "./Components-Pages/College/Calendar/CollegeCalendar";
import Campus from "./Components-Pages/College/Campus";
import Personnel from "./Components-Pages/College/Personnel";
import CollegeHome from "./Components-Pages/College/CollegeHome";
import CollegeTimetable from "./Components-Pages/College/CollegeTimetable";
import NavigateToCollegePreviewProfile from "./Components-Pages/College/NavigateToPreviewProfile";
import NavigateToCollegeSharedProfile from "./Components-Pages/College/NavigateToShareProfile";
import CollegePreviewProfile from "./Components-Pages/College/CollegePreviewProfile";
import CollegeSharedProfile from "./Components-Pages/College/CollegeSharedProfile";
import CollegeDashboard from "./Components-Pages/Dashboard/CollegeDashboard";
import SendLessonMaterials from "./Components-Pages/College/SendLessonMaterials";
import Inbox from "./Components-Pages/College/Inbox";
// import CollegeJobList from "./Components-Pages/Bookings2/CollegeJobList";
import CollegeJobList from "./Components-Pages/Bookings2/CollegeJobListFilter";
import SearchTeacher from "./Components-Pages/College/SearchTeacher";
import FavouriteTeachers from "./Components-Pages/College/FavouriteTeachers";
import BlockedTeachers from "./Components-Pages/College/BlockedTeachers";
import MyHires from "./Components-Pages/College/MyHires";

// Personnel
import PersonnelAccount from "./Components-Pages/Account/PersonnelAccount";
import PersonnelDashboard from "./Components-Pages/Dashboard/PersonnelDashboard";

import FileViewer from "./Components-Pages/FileViewer/FileViewer";
import NavigateToFileViewer from "./Components-Pages/FileViewer/NavigateToViewer";
// import FileViewer from "./Components-Pages/FileViewer/FormViewer"

import dummyRequest from "./Components-Pages/JobBoard/College/DummyRequest";
import AvailabilityTablePage from "./Components-Pages/Admin/Allocation/AvailabilityTablePageArchived";
import AllAvailabilityTable from "./Components-Pages/Admin/Allocation/AllAvailabilityTable";
import InboxCustomer from "./Components-Pages/Bookings2/InboxCustomer";
import GrantAccessPage from "./Components-Pages/GrantAccess";
import TeacherCalendarPage from "./Components-Pages/TeacherCalendar";
import StatisticPage from './Components-Pages/Statistics'
import AllInvoiceTable from "./Components-Pages/Admin/InvoiceTable"
import InvoiceDetail from "./Components-Pages/Admin/InvoiceDetail"
import FinanceSetting from "./Components-Pages/College/Finance/FinanceSetting"
import FinanceCollegeTab from "./Components-Pages/Admin/FinanceSettingCollege/FinanceCollegeTab";


import ECECCheck from "./Components-Pages/User2/ECECCheck";
import UsiCheck from "./Components-Pages/User2/UsiCheck";

import SignContract from './Components-Pages/Contract/SignContract'
import EcecResume from "./Components-Pages/Resume/EcecResume";
import FinanceSettingAdmin from "./Components-Pages/Admin/FinanceSetting/FinanceSettingAdmin";
import PreviewEcecResume from "./Components-Pages/Resume/PreviewEcecResume";
import EcecSharedResume from "./Components-Pages/Resume/EcecSharedResume";

import OAuthGoogleDriveCallback from "./Components-Pages/GoogleDrive/OAuthGoogleDriveCallback";
import BudgetSetting from "./Components-Pages/College/Budget/BudgetSetting";
import TeacherPayLevel from "./Components-Pages/Admin/TeacherPayLevelUpload";

class Routes extends React.Component {
  // When creating a new Route, use TeacherRoute if the user must be signed in as a teacher
  // to access this component or Adminroute if the user must be an admin.

  render() {
    return (
      <BrowserRouter>
        {GA.init() && <GA.RouteTracker />}
        <Switch>
          <TeacherRoute exact path="/testuser" component={TestUser} />
          <AdminRoute exact path="/testadmin" component={TestAdmin} />
          {/* Login and Signup */}
          <Route exact path="/login" component={Login} />
          <Route
            exact
            path="/LoginAsInstitution"
            component={LoginAsInstitution}
          />
          <Route exact path="/RegisterOption" component={RegisterOption} />
          <Route exact path="/register" component={Register} />
          <Route exact path="/registercollege" component={RegisterCollege} />
          <Route exact path="/TeacherOption" component={TeacherOption} />

          <Route
            exact
            path="/beforeEmailConfirm"
            component={BeforeEmailConfirm}
          />
          <Route exact path="/confirm" component={Confirm} />
          <Route exact path="/confirmcollege" component={ConfirmCollege} />
          <Route exact path="/confirmpersonnel" component={ConfirmPersonnel} />
          <Route
            exact
            path="/secondaryRegistration"
            component={secondaryRegistration}
          />
          <Route
            exact
            path="/secondaryRegistrationCollege"
            component={secondaryRegistrationCollege}
          />
          <Route
            exact
            path="/secondaryRegistrationPersonnel"
            component={secondaryRegistrationPersonnel}
          />
          <Route
            exact
            path="/alreadyregistered"
            component={AlreadyRegistered}
          />

          <Route
            exact
            path="/resetpassword/:id/:token"
            component={ResetPassword}
          />
          <Route exact path="/resetSendEmail" component={ResetSendEmail} />

          {/* Home Page */}
          <TeacherRoute exact path="/" component={Home2} />
          <TeacherRoute exact path="/Dashboard" component={Dashboard} />
          <TeacherRoute exact path="/resume" component={Resume3} />
          <TeacherRoute
            exact
            path="/VocationalResume"
            component={VocationalResume}
          />
          <TeacherRoute exact path="/ececResume" component={EcecResume} />
          <TeacherRoute
            exact
            path="/PreviewProfile"
            component={PreviewProfile3}
          />
          <TeacherRoute
            exact
            path="/PreviewResume"
            component={PreviewResume3}
          />
          <TeacherRoute
            exact
            path="/PreviewVetResume"
            component={PreviewVetResume}
          />
          <TeacherRoute
            exact
            path="/PreviewEcecResume"
            component={PreviewEcecResume}
          />

          {/* User Manual */}
          <TeacherRoute
            exact
            path="/UserManual"
            component={TeacherUserManual}
          />
          <AuthorRoute
            permission="256"
            exact
            path="/CollegeUserManual"
            component={CollegeUserManual}
          />

          {/* Share profile navigation page */}
          <Route
            exact
            path="/NavigateToShareProfile"
            component={NavigateToShareProfile}
          />
          <Route
            exact
            path="/NavigateToPreviewProfile"
            component={NavigateToPreviewProfile}
          />
          <Route exact path="/ShareProfile" component={ShareProfile} />
          <Route exact path="/sharedResume" component={SharedResume} />
          <Route exact path="/SharedVetResume" component={SharedVetResume} />
          <Route exact path="/SharedEcecResume" component={EcecSharedResume} />

          {/* Availability */}
          <TeacherRoute exact path="/MyCalendar" component={Availability} />
          {/* <TeacherRoute exact path="/JobList" component={JobList} /> */}
          <Redirect from="/JobList" to="/TeacherJobList" />
          <TeacherRoute
            exact
            path="/TeacherJobList"
            component={TeacherJobList2}
          />

          <TeacherRoute exact path="/GrantAccess" component={GrantAccessPage} />

          {/* Personal info*/}
          <TeacherRoute
            exact
            path="/personalDetails"
            render={(props) => {
              return <PersonalDetails2 {...props} />;
            }}
          />
          <TeacherRoute
            exact
            path="/EmergencyContact"
            render={(props) => {
              return <EmergencyContact2 {...props} />;
            }}
          />
          <TeacherRoute
            exact
            path="/PreferredWorkLocations"
            render={(props) => {
              return <PreferredWorkLocations {...props} />;
            }}
          />
          <TeacherRoute
            exact
            path="/MyAccount"
            render={(props) => {
              return <MyAccount {...props} />;
            }}
          />

          {/* identification */}
          <TeacherRoute
            exact
            path="/PersonalID"
            render={(props) => {
              return <PersonalID2 {...props} />;
            }}
          />
          <TeacherRoute
            exact
            path="/Visa"
            render={(props) => {
              return <Visa2 {...props} />;
            }}
          />
          <TeacherRoute
            exact
            path="/PoliceCheck"
            render={(props) => {
              return <PoliceCheck2 {...props} />;
            }}
          />
          <TeacherRoute
            exact
            path="/WWCC"
            render={(props) => {
              return <WWCC2 {...props} />;
            }}
          />
          <TeacherRoute
            exact
            path="/uploadPayLevel"
            render={(props) => {
              return <PayLevel {...props} />;
            }}
          />
          <TeacherRoute
            exact
            path="/ececcheck"
            render={(props) => {
              return <ECECCheck {...props} />;
            }}
          />
          <TeacherRoute
            exact
            path="/usiCheck"
            render={(props) => {
              return <UsiCheck {...props} />;
            }}
          />

          {/* banking and super */}
          <TeacherRoute
            exact
            path="/BankDetails"
            render={(props) => {
              return <BankDetails {...props} />;
            }}
          />
          <TeacherRoute
            exact
            path="/Tax"
            render={(props) => {
              return <Tax2 {...props} />;
            }}
          />
          <TeacherRoute
            exact
            path="/Superannuation"
            render={(props) => {
              return <Super2 {...props} />;
            }}
          />

          {/* job board */}
          <TeacherRoute
            exact
            path="/JobBoard"
            render={(props) => {
              return <JobBoard {...props} />;
            }}
          />

          <TeacherRoute
            exact
            path="/SavedJobs"
            render={(props) => {
              return <SavedJobs {...props} />;
            }}
          />

          <TeacherRoute
            exact
            path="/MyApplications"
            render={(props) => {
              return <MyApplications {...props} />;
            }}
          />

          <TeacherRoute
            exact
            path="/ConfirmApplication"
            render={(props) => {
              return <ConfirmApplication {...props} />;
            }}
          />

          <AuthorRoute
            permission="256"
            exact
            path="/MyListings"
            render={(props) => {
              return <MyListings {...props} />;
            }}
          />

          <AuthorRoute
            permission="256"
            exact
            path="/MyDrafts"
            render={(props) => {
              return <MyDrafts {...props} />;
            }}
          />

          <AuthorRoute
            permission="256"
            exact
            path="/JobListing/Applicants/:id"
            render={(props) => {
              return <ViewApplicants {...props} />;
            }}
          />

          <AdminRoute
            exact
            path="/JobListing/ApplicantsAdmin/:id"
            render={(props) => {
              return <ViewApplicantsAdmin {...props} />;
            }}
          />

          <AuthorRoute
            permission="256"
            exact
            path="/PostJobDraft"
            render={(props) => {
              return <PostJobDraft {...props} />;
            }}
          />

          <AuthorRoute
            permission="256"
            exact
            path="/PostJobPreview"
            render={(props) => {
              return <PostJobPreview {...props} />;
            }}
          />

          <AuthorRoute
            permission="256"
            exact
            path="/JobListing/Edit/:id"
            render={(props) => {
              return <EditListing {...props} />;
            }}
          />

          <Route
            exact
            path="/JobListing/:id"
            render={(props) => {
              return <JobListing {...props} />;
            }}
          />

          {/* Inbox Customer */}
          <TeacherRoute exact path="/InboxCustomer" component={InboxCustomer} />

          {/* Reference check */}
          <Route
            exact
            path="/NavigateToReferenceForm"
            component={NavigateToReferenceForm}
          />
          <Route exact path="/ReferenceForm" component={ReferenceForm} />

          {/* EllyF and rating */}
          <Route exact path="/feedback" component={NavigateToRating} />
          <Route path="/temporary/rating" component={Rating} />

          {/* For admin */}
          {/* Teacher profiles */}
          {/* <Route exact path='/AllTeachers' component={this.isAdmin(AllTeachers)} /> */}
          <AdminRoute exact path="/AllTeachers" component={AllTeachersTable} />
          <AdminRoute exact path="/AllInvoices" component={AllInvoiceTable} />
          <AdminRoute exact path="/FinanceSettings" component={FinanceSettingAdmin} />
          <AdminRoute exact path="/InvoiceDetail/:id"  component={InvoiceDetail} />
          <AdminRoute exact path="/AllTeachersArchived" component={AllTeachers} />
          <AdminRoute exact path="/AllColleges" component={AllColleges} />
          <AdminRoute
            exact
            path="/AllArchivedColleges"
            component={AllArchivedColleges}
          />
          <AdminRoute exact path="/CollegeDetails" component={CollegeDetails} />
          <AdminRoute
            exact
            path="/CollegeDetailCalendar"
            component={CollegeDetailCalendar}
          />
          <AdminRoute
            exact
            path="/CollegeDetailJobs"
            component={CollegeDetailJobs}
          />
          <AdminRoute
            exact
            path="/CollegeDetailPersonnel"
            component={CollegeDetailPersonnel}
          />
          <AdminRoute
            exact
            path="/CollegeDetailCampus"
            component={CollegeDetailCampus}
          />
          <AdminRoute
            exact
            path="/CollegeDetailTimetable"
            component={CollegeDetailTimetable}
          />
          <AdminRoute
            exact
            path="/CollegeDetailListings"
            component={CollegeDetailListings}
          />
          <AdminRoute exact path="/Statistics" component={StatisticPage} />
          <AdminRoute exact path="/eventCalendar" component={eventCalendar} />
          <AdminRoute exact path="/allocateET" component={allocateET} />
          <AdminRoute exact path="/morningET" component={morningET} />
          <AdminRoute exact path="/managerReport" component={managerReport} />
          <AdminRoute exact path="/TeacherPayLevelUpload" component={TeacherPayLevel} />

          {/* College profiles - lieh */}
          <AdminRoute exact path="/AllCustomers" component={AllCustomers} />
          <AdminRoute
            exact
            path="/TeacherpersonalDetails"
            // component={this.isAdmin(TeacherpersonalDetails)}
            component={TeacherpersonalDetails}
          />
          <AdminRoute
            exact
            path="/TeacherNotes"
            // component={this.isAdmin(TeacherNote)}
            component={TeacherNote}
          />
          <AdminRoute
            exact
            path="/validatedocuments"
            // component={this.isAdmin(ValidateDocuments)}
            component={ValidateDocuments}
          />
          <AdminRoute
            exact
            path="/TeacherJoblistAdmin"
            // component={this.isAdmin(ValidateDocuments)}
            component={TeacherJoblist}
          />

          {/* <Route exact path="/AssignBookings" component={this.isAdmin(AssignBookings)} /> */}
          <AdminRoute exact path="/AssignBookings" component={AssignBookings} />
          <AdminRoute
            exact
            path="/MultipleTeacherAllocation"
            component={MultipleTeacherAllocation}
          />
          <AdminRoute exact path="/allocate" component={AllocationTablePage} />
          <AdminRoute
            exact
            path="/allocation"
            component={AllocationTableNewPage}
          />
          <AdminRoute
            exact
            path="/AllAvailabilityArchived"
            component={AvailabilityTablePage}
          />
          <AdminRoute
            exact
            path="/AllAvailability"
            component={AllAvailabilityTable}
          />
          <AdminRoute
            exact
            path="/Qualifications"
            component={AdminQualification}
          />

          <AdminRoute exact path="/UserLogs" component={UserLogs} />

          {/* Teacher bank details */}
          <AdminRoute
            exact
            path="/TeacherBanking"
            // component={this.isAdmin(TeacherBanking)}
            component={TeacherBanking}
          />
          <AdminRoute
            exact
            path="/TeacherCalendar"
            // component={this.isAdmin(TeacherCalendar)}
            component={TeacherCalendar}
          />

          {/* For college*/}
          <AuthorRoute
            permission="16"
            exact
            path="/CollegeCalendar"
            component={CollegeCalendar}
          />
          {/* <AuthorRoute permission="16" exact path="/CollegeJobList" component={CollegeJobList} /> */}
          <AuthorRoute
            permission="16"
            exact
            path="/CollegeJobList"
            component={CollegeJobList}
          />
          <AuthorRoute exact path="/Profile" component={CollegeHome} />
          <AuthorRoute exact path="/Campus" component={Campus} />
          <AuthorRoute exact path="/Personnel" component={Personnel} />
          <AuthorRoute exact path="/Timetable" component={CollegeTimetable} />
          <AuthorRoute
            exact
            path="/SendLessonMaterials"
            component={SendLessonMaterials}
          />
          <AuthorRoute exact path="/Inbox" component={Inbox} />
          {/* newly added personnel route */}
          <PersonnelRoute
            exact
            path="/PersonnelDashboard"
            component={PersonnelDashboard}
          />
          <CustomerRoute
            exact
            path="/CollegeDashboard"
            component={CollegeDashboard}
          />
          <Route
            exact
            path="/NavigateToCollegePreviewProfile"
            component={NavigateToCollegePreviewProfile}
          />
          <Route
            exact
            path="/NavigateToCollegeSharedProfile"
            component={NavigateToCollegeSharedProfile}
          />
          <AuthorRoute
            exact
            path="/CollegePreviewProfile"
            component={CollegePreviewProfile}
          />
          <Route
            exact
            path="/CollegeSharedProfile"
            component={CollegeSharedProfile}
          />

          {/* PersonnelRoute for PersonnelAccount - lieh */}
          <PersonnelRoute
            exact
            path="/PersonnelAccount"
            render={(props) => {
              return <PersonnelAccount {...props} />;
            }}
          />

          <CustomerRoute
            exact
            path="/CollegeAccount"
            render={(props) => {
              return <CollegeAccount {...props} />;
            }}
          />

          <AuthorRoute 
            exact
            path="/InvoiceTable"
            render={(props) => {
              return <InvoiceTable {...props} />
            }}
          />
            <AuthorRoute 
            exact
            path="/InvoiceDetails/:id"
            render={(props) => {
              return <InvoiceDetails {...props} />
            }}
          />

          <CustomerRoute
           exact
           path="/FinanceSetting"
           render={(props) => {
            return <FinanceSetting {...props} />
           }}
          />

          <CustomerRoute
            exact
            path="/BudgetSetting"
            render={(props) => {
              return <BudgetSetting {...props} />
            }}
          />

          <AuthorRoute exact path="/SearchTeachers" component={SearchTeacher} />
          <AuthorRoute
            exact
            path="/ViewCalendar"
            component={TeacherCalendarPage}
          />
          <AuthorRoute
            exact
            path="/FavouriteTeachers"
            component={FavouriteTeachers}
          />
          <AuthorRoute
            exact
            path="/BlockedTeachers"
            component={BlockedTeachers}
          />
          <AuthorRoute exact path="/MyHires" component={MyHires} />

          {/* For public pages */}
          <UserRoute exact path="/FileViewer" component={FileViewer} />
          <UserRoute
            exact
            path="/NavigateToFileViewer"
            component={NavigateToFileViewer}
          />
          <AdminRoute exact path="/FinanceSettingCollege" component={FinanceCollegeTab} />

          <AuthorRoute
            exact
            path="/SignContract"
            render={(props) => {
              return <SignContract {...props} />;
            }}
          />

          <Route exact path="/DummyPage" component={dummyRequest} />

          <Route exact path="/oauth2callback" component={OAuthGoogleDriveCallback} />

          <Route render={() => <h1>404</h1>} />
        </Switch>
      </BrowserRouter>
    );
  }
}

export default Routes;
